import { $set, update } from 'qim';

import ActionTypes from 'app/shared-zap/ActionTypes';
import { createReducer } from 'app/common/utils/ReduxUtils';

const initialState = {
  sharedZaps: {},
  // Not real flows, just enough to make the editor happy for showing a start
  // page.
  flows: {},
};

const sharedZapHandlers = {
  [ActionTypes.LOAD_SHARED_ZAP_DONE](state, { result }) {
    const { id } = result;
    return update(['sharedZaps', id, $set(result)], state);
  },

  // Really, this should probably just be derived data.
  [ActionTypes.ADD_SHARED_ZAP_FLOW](state, { id, flow }) {
    return update(['flows', id, $set(flow)], state);
  },
};

const reducer = createReducer(sharedZapHandlers, initialState);

export default reducer;
